export default [
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/feedBack/Index.vue'),
    meta: {
      title: '反馈记录',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/feedback-create',
    name: 'feedback-create',
    component: () => import('@/views/feedBack/Create.vue'),
    meta: {
      title: '反馈与投诉',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/feedback-result',
    name: 'feedback-result',
    component: () => import('@/views/feedBack/Result.vue'),
    meta: {
      title: '反馈',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/feedback-detail-:id',
    name: 'feedback-detail',
    component: () => import('@/views/feedBack/Detail.vue'),
    meta: {
      title: '反馈详情',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
  {
    path: '/feedback-supplement-:id',
    name: 'feedback-supplement',
    component: () => import('@/views/feedBack/Create.vue'),
    meta: {
      title: '反馈与投诉',
      auth: 0,
      backgroundClass: 'bg-black',
    },
  },
];
